export const employerScenarios: {
  [key: string]: unknown;
} = {
  'I-1': [
    'Одобрение от работодател',
    'Подпис от работодател',
    'Изпращане към служител',
    'Одобрение от служител',
    'Подпис от служител',
    'Изпращане към работодател',
    'Изпращане в Архив',
  ],
  'I-2': ['Одобрение от работодател', 'Подпис от работодател', 'Изпращане към служител', 'Изпращане в Архив'],
  'I-3': [
    'Изпращане към служител',
    'Одобрение от служител',
    'Подпис от служител',
    'Изпращане към работодател',
    'Изпращане в Архив',
  ],
  'I-4': [
    'Изпращане към служител',
    'Одобрение от служител',
    'Подпис от служител',
    'Изпращане към работодател',
    'Одобрение от работодател',
    'Подпис от работодател',
    'Изпращане в Архив',
  ],
};

export const employeeScenarios: {
  [key: string]: unknown;
} = {
  'II-1': [
    'Одобрение от служител',
    'Подпис от служител',
    'Изпращане към работодател',
    'Одобрение от работодател',
    'Подпис от работодател',
    'Изпращане в Архив',
  ],
  'II-2': ['Одобрение от служител', 'Подпис от служител', 'Изпращане към работодател', 'Изпращане в Архив'],
};
